import React, { useRef, useState } from 'react';
import { toast } from 'sonner';
import { FileSpreadsheet, Download, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { scoutBulkCsv, scoutTemplateUrl, apiError } from '../../services/scoutApi';

export const BulkScanCard = ({ region, onStarted }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      if (region) fd.append('region', region);
      const r = await scoutBulkCsv(fd);
      toast.success(`Scanning ${r.count} candidate${r.count === 1 ? '' : 's'}${r.skipped ? ` (${r.skipped} rows skipped)` : ''}`);
      onStarted?.(r.batch_id);
    } catch (e) { toast.error(apiError(e, 'Upload failed')); } finally { setBusy(false); if (input.current) input.current.value = ''; }
  };

  return (
    <div className="rounded-2xl border bg-card p-5 space-y-3" data-testid="scout-bulk-card">
      <div>
        <h3 className="text-sm font-bold flex items-center gap-2"><FileSpreadsheet className="h-4 w-4 text-primary" /> Bulk scan</h3>
        <p className="text-xs text-muted-foreground mt-1">Upload a CSV of up to 500 applicants — name, email, phone, linkedin, github, location, vendor.</p>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" className="flex-1 gap-2" disabled={busy} onClick={() => input.current?.click()} data-testid="scout-bulk-upload-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSpreadsheet className="h-4 w-4" />} Upload CSV
        </Button>
        <Button variant="ghost" className="gap-1.5" asChild>
          <a href={scoutTemplateUrl} data-testid="scout-csv-template-link"><Download className="h-4 w-4" /> Template</a>
        </Button>
      </div>
      <input ref={input} type="file" accept=".csv,text/csv" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="scout-bulk-input" />
    </div>
  );
};

export default BulkScanCard;
